import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

const EmailAction = () => {
  const { refId } = useParams();
  const { search } = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const q = new URLSearchParams(search);
    const action = q.get('action');
    const token = q.get('token');
    const role = q.get('role');

    if (!action || !token || !role) {
      setStatus('error');
      setMessage('Missing required parameters (action, role, token).');
      return;
    }

   // Update the doAction async function (add try-catch for fetch and better message parsing)
const doAction = async () => {
  try {
    const baseUrl = process.env.REACT_APP_API_BASE || 'https://api.zauntrip.net';
    const url = `${baseUrl}/packages/${encodeURIComponent(refId)}/email-action?action=${encodeURIComponent(action)}&role=${encodeURIComponent(role)}&token=${encodeURIComponent(token)}`;

    const res = await fetch(url, { method: 'GET' });

    if (!res.ok) {
      const errorText = await res.text();
      setStatus('error');
      setMessage(errorText || 'Action failed. Please try from the portal or contact support.');
      return;
    }

    const text = await res.text();
    setStatus('success');
    setMessage(text);
  } catch (err) {
    setStatus('error');
    setMessage(err.message || 'Network error. Please check your connection.');
  }
};
    doAction();
  }, [refId, search]);

  useEffect(() => {
    if (status === 'success') {
      const t = setTimeout(() => navigate('/dashboard/view-packages'), 2500);
      return () => clearTimeout(t);
    }
  }, [status, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-lg w-full bg-white shadow rounded p-6 text-center">

        {status === 'processing' && (
          <>
            <h2 className="text-xl font-semibold mb-4">Processing...</h2>
            <p className="text-sm text-gray-600">Validating approval token...</p>
            <div className="mt-6">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2"></div>
            </div>
          </>
        )}

        {status === 'success' && (
          <>
            <h2 className="text-xl font-semibold mb-2 text-green-600">Success</h2>
            <div dangerouslySetInnerHTML={{ __html: message }} />
            <p className="mt-4 text-sm text-gray-500">Redirecting...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <h2 className="text-xl font-semibold mb-2 text-red-600">Error</h2>
            <div dangerouslySetInnerHTML={{ __html: message }} />
            <button
              className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded"
              onClick={() => navigate('/dashboard/view-packages')}
            >
              Back to Packages
            </button>
          </>
        )}

      </div>
    </div>
  );
};

export default EmailAction;